module.exports = __webpack_public_path__ + "static/media/qluster.e61bf5b5.png";